import { getCurrentInstance } from "vue"
export const useGetGlobalProperties = () => {
	const {emit, appContext: {app: {config: {globalProperties}}}} = getCurrentInstance()
	
	return {...globalProperties}
}